import {OvenReport, PropertyValue} from "../../types";
import React from "react";
import {BlockTitleComponent} from "../common/BlockTitleComponent";
import {getShiftName, getTypeName} from "../../common";

export interface ViewOvenReportProperties {
    report: OvenReport,
    shifts: PropertyValue[],
    pelet_types: PropertyValue[],
    bag_types: PropertyValue[],
}

interface OvenReportState {
}

export class ViewOvenReportComponent extends React.Component<ViewOvenReportProperties, OvenReportState> {

    constructor(props: ViewOvenReportProperties) {
        super(props);
        this.state = {}
    }


    render() {
        const rd = JSON.parse(this.props.report.request_data);
        if(rd['production'])
        rd['production'].forEach(
            (i: any) => rd['wagonQty_' + i.brick_id] = i.wagon_qty
        )

        return (
            <>
                <div className="card shadow">
                    <div className={"card-body"}>
                        <div className="form-row mb-3">
                            <div className="col">
                                Дата:<br/><strong>{this.props.report.base_info.report_date}</strong>
                            </div>
                            <div className="col">
                                Смяна:<br/><strong>{getShiftName(this.props.shifts, this.props.report.base_info.shift_id)}</strong>
                            </div>
                            <div className="col">
                                Брой служители:<br/><strong>{this.props.report.base_info.man_cnt}</strong>
                            </div>
                            <div className="col-auto">
                                Попълнил отчета:<br/><strong>{this.props.report.user.name}</strong>
                            </div>
                        </div>
                        <div className="form-row mb-3">
                            <div className="col-12 m-0 p-0">
                                <BlockTitleComponent title={"Произведено"}/>
                                <div className={"row ml-2 mr-2"}>
                                    <table className="table table-sm table-bordered table-no-padding" >
                                        <thead>
                                        <tr className="text-center">
                                            <th>4-ка ПЛЪТНА</th>
                                            <th>4 1/2 ПЛЪТНА</th>
                                            <th>4-ка ТЕРМО</th>
                                            <th>4 1/2 ТЕРМО</th>
                                            <th>ЕДИНИЧКА</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr className="text-center">
                                            <td>{rd['wagonQty_0'] || ''}</td>
                                            <td>{rd['wagonQty_1'] || ''}</td>
                                            <td>{rd['wagonQty_2'] || ''}</td>
                                            <td>{rd['wagonQty_3'] || ''}</td>
                                            <td>{rd['wagonQty_4'] || ''}</td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div className="form-row mb-3">
                            <div className="col-12 m-0 p-0">
                                <BlockTitleComponent title={"Разход пелети пещ"}/>
                                <table className={"table-sm table-bordered w-100"}>
                                    <thead>
                                    <th>Час</th>
                                    <th>Вид пелети</th>
                                    <th>Вид баг</th>
                                    <th>Брой багове</th>
                                    </thead>
                                    <tbody>
                                    {
                                        rd.chargings?.map(
                                            (i: any, idx: number) =>
                                                <tr key={idx}>
                                                    <td>{i.chargeTime}</td>
                                                    <td>{ getTypeName(this.props.pelet_types, i.pelet) }</td>
                                                    <td>{ getTypeName(this.props.bag_types, i.bagType)}</td>
                                                    <td>{i.bagQty}</td>
                                                </tr>
                                        )
                                    }
                                    </tbody>
                                </table>
                                {
                                    (!rd.chargings || rd.chargings.length === 0) &&
                                    <div>Не е извършено</div>
                                }
                            </div>
                        </div>
                        <div className="form-row mb-3">
                            <div className="col-12 m-0 p-0">
                                <BlockTitleComponent title={"Разход пелети печка"}/>
                                <table className={"table-sm table-bordered w-100"}>
                                    <thead>
                                    <th>Час</th>
                                    <th>Вид пелети</th>
                                    <th>Вид баг</th>
                                    <th>Брой багове</th>
                                    </thead>
                                    <tbody>
                                    {
                                        rd.heater_chargings?.map(
                                            (i: any, idx: number) =>
                                                <tr key={idx}>
                                                    <td>{i.chargeTime}</td>
                                                    <td>{ getTypeName(this.props.pelet_types, i.pelet) }</td>
                                                    <td>{ getTypeName(this.props.bag_types, i.bagType)}</td>
                                                    <td>{i.bagQty}</td>
                                                </tr>
                                        )
                                    }
                                    </tbody>
                                </table>
                                {
                                    (!rd.heater_chargings || rd.heater_chargings.length === 0) &&
                                    <div>Не е извършено</div>
                                }
                            </div>
                        </div>
                        <div className="form-row mb-3">
                            <div className="col-12 m-0 p-0">
                                <BlockTitleComponent title={"Бележки към отчета"}/>
                                <div>
                                    { rd.comments || "Няма бележки към отчета" }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}
